import { useWorkoutData } from "./hooks/useWorkoutData.js";
import SearchScreen from "./components/SearchScreen.jsx";
import Dashboard from "./components/Dashboard.jsx";
import ComparisonScreen from "./components/ComparisonScreen.jsx";

export default function App() {
  const { state, search, setPeriod, startComparison, removeComparison, exitComparison, reset } = useWorkoutData();

  const onDashboard = state.screen === "dashboard";
  const onComparison = state.screen === "comparison";

  return (
    <>
      <SearchScreen
        key={state.searchKey}
        id="screen-search"
        hidden={onDashboard || onComparison}
        defaultUsername={state.username}
        onSearch={search}
        loading={state.screen === "loading"}
        loadingStatus={state.status}
        loadingDetail={state.historyProgress}
        error={state.error}
      />
      <Dashboard
        id="screen-app"
        hidden={!onDashboard}
        state={state}
        onPeriodChange={setPeriod}
        onNewSearch={reset}
        onStartComparison={startComparison}
      />
      {onComparison && state.compare?.profiles?.length > 0 && (
        <ComparisonScreen
          profiles={[
            {
              username: state.username,
              status: "ready",
              preview: state.preview,
              analytics: state.analytics,
              weightUnit: state.weightUnit,
              dataStatus: state.dataStatus
            },
            ...state.compare.profiles
          ]}
          periodDays={state.periodDays}
          onPeriodChange={setPeriod}
          onAddProfile={startComparison}
          onRemoveProfile={removeComparison}
          onExit={exitComparison}
          onNewSearch={reset}
        />
      )}
    </>
  );
}
